import React, { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
//@ts-ignore
import { Document, Page, pdfjs } from 'react-pdf'

import DocumentViewerZoomButtons from './DocumentViewerZoomButtons'
import SkeletonLoader from 'components/skeletonloader/SkeletonLoader'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

interface IDocumentViewerProps {
	blob: Blob
	docScale: number
	setScale: Function
}

const DocumentViewer = ({ blob, docScale, setScale }: IDocumentViewerProps) => {
	const { t } = useTranslation()
	const [numPages, setNumPages] = useState(0)
	const [docWidth, setDocWidth] = useState<number>()
	const [docHeight, setDocHeight] = useState<number>()

	const getDeviceWidth = useCallback(() => {
		let element = document.getElementById('document-viewer-container')
		if (element) {
			setDocHeight(element.offsetHeight)
			setDocWidth(element.offsetWidth - 15)
		}
	}, [])

	const onDocumentLoadSuccess = useCallback(
		({ numPages }: any) => {
			setNumPages(numPages)
			getDeviceWidth()
		},
		[getDeviceWidth]
	)

	const getDocument = useCallback(
		(blob: any) => {
			return (
				<React.Fragment>
					<Document
						file={window.URL.createObjectURL(blob)}
						onLoadSuccess={onDocumentLoadSuccess}
						renderTextLayer={false}
						error={<ErrorBox message={t('ErrorViewPn')} />}
						loading={
							<SkeletonLoader
								width={docWidth ? docWidth + 'px' : '100%'}
								height={docHeight ? docHeight + 'px' : '100%'}
							/>
						}
						noData={t('ErrorViewPn')}
						renderMode={'canvas'}>
						{Array.from(new Array(numPages), (el, index) => (
							<Page
								key={`page_${index + 1}`}
								pageNumber={index + 1}
								renderTextLayer={false}
								renderAnnotationLayer={false}
								width={docWidth}
								height={docHeight}
								scale={docScale}
								loading={
									<SkeletonLoader
										width={
											docWidth ? docWidth + 'px' : '100%'
										}
										height={
											docHeight
												? docHeight + 'px'
												: '100%'
										}
									/>
								}
							/>
						))}
					</Document>
					<DocumentViewerZoomButtons docScale={docScale} setScale={setScale} />
				</React.Fragment>
			)
		},
		[docWidth, docHeight, docScale, setScale, onDocumentLoadSuccess, t, numPages]
	)

	return <div className="document-viewer-container">{getDocument(blob)}</div>
}

export default DocumentViewer
